import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["loading"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.IsShwoOffPayMent && _ctx.typebtn == 'primary')
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "approval-btn-void",
          loading: _ctx.loading,
          disabled: false,
          onClick: _ctx.offPayment
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btnName), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.typebtn == 'text')
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: "javascript:void(0);",
          loading: _ctx.loading,
          type: "link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.offPayment && _ctx.offPayment(...args))),
          class: "theme-color",
          style: _normalizeStyle(_ctx.btnName == '取消申请' ? { color: '#2F7BFF' } : { color: '#ff4d4f' })
        }, _toDisplayString(_ctx.btnName), 13, _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}